import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { ToggleLoadingOff, ToggleLoadingOn } from './loading-modal.actions';

interface LoadingModalStateModel {
	loading: boolean;
	title: string;
	subtitle: string;
}
type Ctx = StateContext<LoadingModalStateModel>;

const DEFAULT_STATE: LoadingModalStateModel = {
	loading: false,
	title: '',
	subtitle: '',
};

@State<LoadingModalStateModel>({
	name: 'loadingModalState',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class LoadingModalState {
	constructor() {}

	@Selector([LoadingModalState])
	static loading(state: LoadingModalStateModel): boolean {
		return state.loading;
	}

	@Selector([LoadingModalState])
	static title(state: LoadingModalStateModel): string {
		return state.title;
	}

	@Selector([LoadingModalState])
	static subtitle(state: LoadingModalStateModel): string {
		return state.subtitle;
	}

	@Action(ToggleLoadingOff)
	toggleLoadingOff(ctx: Ctx, action: ToggleLoadingOff): void {
		if (action.timeBufferMS) {
			timer(action.timeBufferMS)
				.pipe(take(1))
				.subscribe(() => {
					ctx.patchState({ loading: false });
				});
		} else {
			ctx.patchState({ loading: false });
		}
	}

	@Action(ToggleLoadingOn)
	toggleLoadingOn(ctx: Ctx, action: ToggleLoadingOn): void {
		ctx.patchState({
			loading: true,
			title: action.title,
			subtitle: action.subtitle,
		});
	}
}
